import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';

const CustomHidden = ({ up, down, children }) => {
  const minWidth = useMediaQuery(`(min-width:${up}px)`);
  const maxWidth = useMediaQuery(`(max-width:${down}px)`);

  const isHiddenFrom = up ? minWidth : false;
  const isHiddenUntil = down ? maxWidth : false;

  if (isHiddenFrom || isHiddenUntil) return null;

  return <>{children}</>;
};

CustomHidden.propTypes = {
  up: PropTypes.number,
  down: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CustomHidden;
